// This is all you.
import './misc/alpinejs-i18n';
import './alpine';
import './navbar';

import { Fancybox } from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]', {
  //
});
